var _ref, _ref2;

function cov_1q9eio50nx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx";
  var hash = "e0948d7eca600933473d93c0ae227e11a6cb9ed6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/Spritesheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 161,
          column: 70
        },
        end: {
          line: 302,
          column: 1
        }
      },
      "1": {
        start: {
          line: 306,
          column: 86
        },
        end: {
          line: 316,
          column: 1
        }
      },
      "2": {
        start: {
          line: 340,
          column: 2
        },
        end: {
          line: 355,
          column: 4
        }
      },
      "3": {
        start: {
          line: 344,
          column: 10
        },
        end: {
          line: 344,
          column: 92
        }
      },
      "4": {
        start: {
          line: 347,
          column: 10
        },
        end: {
          line: 351,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "Spritesheet",
        decl: {
          start: {
            line: 339,
            column: 24
          },
          end: {
            line: 339,
            column: 35
          }
        },
        loc: {
          start: {
            line: 339,
            column: 38
          },
          end: {
            line: 356,
            column: 1
          }
        },
        line: 339
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 343,
            column: 44
          },
          end: {
            line: 343,
            column: 45
          }
        },
        loc: {
          start: {
            line: 344,
            column: 10
          },
          end: {
            line: 344,
            column: 92
          }
        },
        line: 344
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 346,
            column: 58
          },
          end: {
            line: 346,
            column: 59
          }
        },
        loc: {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 351,
            column: 12
          }
        },
        line: 347
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e0948d7eca600933473d93c0ae227e11a6cb9ed6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1q9eio50nx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1q9eio50nx();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { bricks } from '../../system/bricks.types';
import ThreeSixty from './SpritesheetIcons/ThreeSixty';
import ThreeSixtyVersionTwo from './SpritesheetIcons/ThreeSixtyVerisonTwo';
import ArrowDown from './SpritesheetIcons/ArrowDown';
import ArrowLeft from './SpritesheetIcons/ArrowLeft';
import ArrowRight from './SpritesheetIcons/ArrowRight';
import ArrowUp from './SpritesheetIcons/ArrowUp';
import Avatar from './SpritesheetIcons/Avatar';
import AvatarFilled from './SpritesheetIcons/AvatarFilled';
import Bathroom from './SpritesheetIcons/Bathroom';
import BathroomFilled from './SpritesheetIcons/BathroomFilled';
import BathroomVersionTwo from './SpritesheetIcons/BathroomVersionTwo';
import BathroomVersionTwoFilled from './SpritesheetIcons/BathroomVersionTwoFilled';
import Bedroom from './SpritesheetIcons/Bedroom';
import BedroomFilled from './SpritesheetIcons/BedroomFilled';
import Chat from './SpritesheetIcons/Chat';
import ChatInactive from './SpritesheetIcons/ChatInactive';
import ChatVersionTwo from './SpritesheetIcons/ChatVersionTwo';
import ChatVersionTwoFilled from './SpritesheetIcons/ChatVersionTwoFilled';
import Checkmark from './SpritesheetIcons/Checkmark';
import ChevronDown from './SpritesheetIcons/ChevronDown';
import ChevronLeft from './SpritesheetIcons/ChevronLeft';
import ChevronRight from './SpritesheetIcons/ChevronRight';
import ChevronUp from './SpritesheetIcons/ChevronUp';
import Close from './SpritesheetIcons/Close';
import Date from './SpritesheetIcons/Date';
import DateFilled from './SpritesheetIcons/DateFilled';
import DateAdd from './SpritesheetIcons/DateAdd';
import DateAddFilled from './SpritesheetIcons/DateAddFilled';
import DateChecked from './SpritesheetIcons/DateChecked';
import DateCheckedFilled from './SpritesheetIcons/DateCheckedFilled';
import DateSubtract from './SpritesheetIcons/DateSubtract';
import DateSubtractFilled from './SpritesheetIcons/DateSubtractFilled';
import DocumentCheck from './SpritesheetIcons/DocumentCheck';
import DocumentCheckFilled from './SpritesheetIcons/DocumentCheckFilled';
import Door from './SpritesheetIcons/Door';
import DoorFilled from './SpritesheetIcons/DoorFilled';
import DoubleChevron from './SpritesheetIcons/DoubleChevron';
import DoubleMove from './SpritesheetIcons/DoubleMove';
import EarlyAccess from './SpritesheetIcons/EarlyAccess';
import Edit from './SpritesheetIcons/Edit';
import EditFilled from './SpritesheetIcons/EditFilled';
import Email from './SpritesheetIcons/Email';
import EmailFilled from './SpritesheetIcons/EmailFilled';
import Equal from './SpritesheetIcons/Equal';
import Expertise from './SpritesheetIcons/Expertise';
import Favorite from './SpritesheetIcons/Favorite';
import FavoriteFilled from './SpritesheetIcons/FavoriteFilled';
import Filter from './SpritesheetIcons/Filter';
import Garage from './SpritesheetIcons/Garage';
import GarageFilled from './SpritesheetIcons/GarageFilled';
import Geo from './SpritesheetIcons/Geo';
import GeoFilled from './SpritesheetIcons/GeoFilled';
import Home from './SpritesheetIcons/Home';
import HomeFilled from './SpritesheetIcons/HomeFilled';
import HomeChat from './SpritesheetIcons/HomeChat';
import HomeChatFilled from './SpritesheetIcons/HomeChatFilled';
import HomeCost from './SpritesheetIcons/HomeCost';
import HomeCostFilled from './SpritesheetIcons/HomeCostFilled';
import HomeLocation from './SpritesheetIcons/HomeLocation';
import HomeLocationFilled from './SpritesheetIcons/HomeLocationFilled';
import Info from './SpritesheetIcons/Info';
import InfoFilled from './SpritesheetIcons/InfoFilled';
import Invite from './SpritesheetIcons/Invite';
import InviteFilled from './SpritesheetIcons/InviteFilled';
import Jewel from './SpritesheetIcons/Jewel';
import Levels from './SpritesheetIcons/Levels';
import LevelsFilled from './SpritesheetIcons/LevelsFilled';
import List from './SpritesheetIcons/List';
import Location from './SpritesheetIcons/Location';
import LocationPin from './SpritesheetIcons/LocationPin';
import LocationPinFilled from './SpritesheetIcons/LocationPinFilled';
import LocationPinHome from './SpritesheetIcons/LocationPinHome';
import LocationPinHomeFilled from './SpritesheetIcons/LocationPinHomeFilled';
import Lock from './SpritesheetIcons/Lock';
import LockFilled from './SpritesheetIcons/LockFilled';
import Logo from './SpritesheetIcons/Logo';
import Map from './SpritesheetIcons/Map';
import Menu from './SpritesheetIcons/Menu';
import Minus from './SpritesheetIcons/Minus';
import Money from './SpritesheetIcons/Money';
import Move from './SpritesheetIcons/Move';
import MoveFilled from './SpritesheetIcons/MoveFilled';
import MultipleOffers from './SpritesheetIcons/MultipleOffers';
import MultipleOffersFilled from './SpritesheetIcons/MultipleOffersFilled';
import Neighborhood from './SpritesheetIcons/Neighborhood';
import NeighborhoodFilled from './SpritesheetIcons/NeighborhoodFilled';
import New from './SpritesheetIcons/New';
import NewConstruction from './SpritesheetIcons/NewConstruction';
import NewTab from './SpritesheetIcons/NewTab';
import NewTabFilled from './SpritesheetIcons/NewTabFilled';
import Notification from './SpritesheetIcons/Notification';
import Obo from './SpritesheetIcons/Obo';
import Offer from './SpritesheetIcons/Offer';
import OfferInactive from './SpritesheetIcons/OfferInactive';
import Open from './SpritesheetIcons/Open';
import Pdf from './SpritesheetIcons/Pdf';
import Phone from './SpritesheetIcons/Phone';
import PhoneFilled from './SpritesheetIcons/PhoneFilled';
import Placeholder from './SpritesheetIcons/Placeholder';
import Plus from './SpritesheetIcons/Plus';
import Popular from './SpritesheetIcons/Popular';
import Question from './SpritesheetIcons/Question';
import Rate from './SpritesheetIcons/Rate';
import Refresh from './SpritesheetIcons/Refresh';
import RefreshFilled from './SpritesheetIcons/RefreshFilled';
import Reset from './SpritesheetIcons/Reset';
import Search from './SpritesheetIcons/Search';
import SearchFilled from './SpritesheetIcons/SearchFilled';
import See from './SpritesheetIcons/See';
import SeeFilled from './SpritesheetIcons/SeeFilled';
import SeeHidden from './SpritesheetIcons/SeeHidden';
import Share from './SpritesheetIcons/Share';
import ShareFilled from './SpritesheetIcons/ShareFilled';
import Shower from './SpritesheetIcons/Shower';
import ShowerFilled from './SpritesheetIcons/ShowerFilled';
import Sign from './SpritesheetIcons/Sign';
import SignFilled from './SpritesheetIcons/SignFilled';
import Sink from './SpritesheetIcons/Sink';
import SinkFilled from './SpritesheetIcons/SinkFilled';
import SinkVersionTwo from './SpritesheetIcons/SinkVersionTwo';
import SinkVersionTwoFilled from './SpritesheetIcons/SinkVersionTwoFilled';
import Sliders from './SpritesheetIcons/Sliders';
import SlidersFilled from './SpritesheetIcons/SlidersFilled';
import SquareFeet from './SpritesheetIcons/SquareFeet';
import SquareFeetFilled from './SpritesheetIcons/SquareFeetFilled';
import Star from './SpritesheetIcons/Star';
import StarFilled from './SpritesheetIcons/StarFilled';
import Telephone from './SpritesheetIcons/Telephone';
import Trash from './SpritesheetIcons/Trash';
import TrashFilled from './SpritesheetIcons/TrashFilled';
import UnlockLeft from './SpritesheetIcons/UnlockLeft';
import UnlockLeftFilled from './SpritesheetIcons/UnlockLeftFilled';
import UnlockRight from './SpritesheetIcons/UnlockRight';
import UnlockRightFilled from './SpritesheetIcons/UnlockRightFilled';
import Video from './SpritesheetIcons/Video';
import VideoFilled from './SpritesheetIcons/VideoFilled';
import Warning from './SpritesheetIcons/Warning'; // Old Sprite Sheets below: please update to new designs and naming

import Opendoor from './SpritesheetIcons/Opendoor';
import ProgressBar from './SpritesheetIcons/ProgressBar'; // size-specific icons

import ChevronDown12 from './SpritesheetIcons/ChevronDown12';
import ChevronDown16 from './SpritesheetIcons/ChevronDown16';
import ChevronLeft12 from './SpritesheetIcons/ChevronLeft12';
import ChevronLeft16 from './SpritesheetIcons/ChevronLeft16';
import ChevronRight12 from './SpritesheetIcons/ChevronRight12';
import ChevronRight16 from './SpritesheetIcons/ChevronRight16';
import ChevronUp12 from './SpritesheetIcons/ChevronUp12';
import ChevronUp16 from './SpritesheetIcons/ChevronUp16';
import Close16 from './SpritesheetIcons/Close16'; // DO NOT EXPORT: If you need all the names of the icons, use the
// SPRITESHEET_ICONS_MANIFEST

var SPRITESHEET_ICONS = (cov_1q9eio50nx().s[0]++, (_ref = {}, _defineProperty(_ref, ThreeSixty.name, ThreeSixty.svg), _defineProperty(_ref, ThreeSixtyVersionTwo.name, ThreeSixtyVersionTwo.svg), _defineProperty(_ref, ArrowDown.name, ArrowDown.svg), _defineProperty(_ref, ArrowLeft.name, ArrowLeft.svg), _defineProperty(_ref, ArrowRight.name, ArrowRight.svg), _defineProperty(_ref, ArrowUp.name, ArrowUp.svg), _defineProperty(_ref, Avatar.name, Avatar.svg), _defineProperty(_ref, AvatarFilled.name, AvatarFilled.svg), _defineProperty(_ref, Bathroom.name, Bathroom.svg), _defineProperty(_ref, BathroomFilled.name, BathroomFilled.svg), _defineProperty(_ref, BathroomVersionTwo.name, BathroomVersionTwo.svg), _defineProperty(_ref, BathroomVersionTwoFilled.name, BathroomVersionTwoFilled.svg), _defineProperty(_ref, Bedroom.name, Bedroom.svg), _defineProperty(_ref, BedroomFilled.name, BedroomFilled.svg), _defineProperty(_ref, Chat.name, Chat.svg), _defineProperty(_ref, ChatInactive.name, ChatInactive.svg), _defineProperty(_ref, ChatVersionTwo.name, ChatVersionTwo.svg), _defineProperty(_ref, ChatVersionTwoFilled.name, ChatVersionTwoFilled.svg), _defineProperty(_ref, Checkmark.name, Checkmark.svg), _defineProperty(_ref, ChevronDown.name, ChevronDown.svg), _defineProperty(_ref, ChevronLeft.name, ChevronLeft.svg), _defineProperty(_ref, ChevronRight.name, ChevronRight.svg), _defineProperty(_ref, ChevronUp.name, ChevronUp.svg), _defineProperty(_ref, Close.name, Close.svg), _defineProperty(_ref, Date.name, Date.svg), _defineProperty(_ref, DateFilled.name, DateFilled.svg), _defineProperty(_ref, DateAdd.name, DateAdd.svg), _defineProperty(_ref, DateAddFilled.name, DateAddFilled.svg), _defineProperty(_ref, DateChecked.name, DateChecked.svg), _defineProperty(_ref, DateCheckedFilled.name, DateCheckedFilled.svg), _defineProperty(_ref, DateSubtract.name, DateSubtract.svg), _defineProperty(_ref, DateSubtractFilled.name, DateSubtractFilled.svg), _defineProperty(_ref, DocumentCheck.name, DocumentCheck.svg), _defineProperty(_ref, DocumentCheckFilled.name, DocumentCheckFilled.svg), _defineProperty(_ref, Door.name, Door.svg), _defineProperty(_ref, DoorFilled.name, DoorFilled.svg), _defineProperty(_ref, DoubleChevron.name, DoubleChevron.svg), _defineProperty(_ref, DoubleMove.name, DoubleMove.svg), _defineProperty(_ref, EarlyAccess.name, EarlyAccess.svg), _defineProperty(_ref, Edit.name, Edit.svg), _defineProperty(_ref, EditFilled.name, EditFilled.svg), _defineProperty(_ref, Email.name, Email.svg), _defineProperty(_ref, EmailFilled.name, EmailFilled.svg), _defineProperty(_ref, Equal.name, Equal.svg), _defineProperty(_ref, Expertise.name, Expertise.svg), _defineProperty(_ref, Favorite.name, Favorite.svg), _defineProperty(_ref, FavoriteFilled.name, FavoriteFilled.svg), _defineProperty(_ref, Filter.name, Filter.svg), _defineProperty(_ref, Garage.name, Garage.svg), _defineProperty(_ref, GarageFilled.name, GarageFilled.svg), _defineProperty(_ref, Geo.name, Geo.svg), _defineProperty(_ref, GeoFilled.name, GeoFilled.svg), _defineProperty(_ref, Home.name, Home.svg), _defineProperty(_ref, HomeFilled.name, HomeFilled.svg), _defineProperty(_ref, HomeChat.name, HomeChat.svg), _defineProperty(_ref, HomeChatFilled.name, HomeChatFilled.svg), _defineProperty(_ref, HomeCost.name, HomeCost.svg), _defineProperty(_ref, HomeCostFilled.name, HomeCostFilled.svg), _defineProperty(_ref, HomeLocation.name, HomeLocation.svg), _defineProperty(_ref, HomeLocationFilled.name, HomeLocationFilled.svg), _defineProperty(_ref, Info.name, Info.svg), _defineProperty(_ref, InfoFilled.name, InfoFilled.svg), _defineProperty(_ref, Invite.name, Invite.svg), _defineProperty(_ref, InviteFilled.name, InviteFilled.svg), _defineProperty(_ref, Jewel.name, Jewel.svg), _defineProperty(_ref, Levels.name, Levels.svg), _defineProperty(_ref, LevelsFilled.name, LevelsFilled.svg), _defineProperty(_ref, List.name, List.svg), _defineProperty(_ref, Location.name, Location.svg), _defineProperty(_ref, LocationPin.name, LocationPin.svg), _defineProperty(_ref, LocationPinFilled.name, LocationPinFilled.svg), _defineProperty(_ref, LocationPinHome.name, LocationPinHome.svg), _defineProperty(_ref, LocationPinHomeFilled.name, LocationPinHomeFilled.svg), _defineProperty(_ref, Lock.name, Lock.svg), _defineProperty(_ref, LockFilled.name, LockFilled.svg), _defineProperty(_ref, Logo.name, Logo.svg), _defineProperty(_ref, Map.name, Map.svg), _defineProperty(_ref, Menu.name, Menu.svg), _defineProperty(_ref, Minus.name, Minus.svg), _defineProperty(_ref, Money.name, Money.svg), _defineProperty(_ref, Move.name, Move.svg), _defineProperty(_ref, MoveFilled.name, MoveFilled.svg), _defineProperty(_ref, MultipleOffers.name, MultipleOffers.svg), _defineProperty(_ref, MultipleOffersFilled.name, MultipleOffersFilled.svg), _defineProperty(_ref, Neighborhood.name, Neighborhood.svg), _defineProperty(_ref, NeighborhoodFilled.name, NeighborhoodFilled.svg), _defineProperty(_ref, New.name, New.svg), _defineProperty(_ref, NewConstruction.name, NewConstruction.svg), _defineProperty(_ref, NewTab.name, NewTab.svg), _defineProperty(_ref, NewTabFilled.name, NewTabFilled.svg), _defineProperty(_ref, Notification.name, Notification.svg), _defineProperty(_ref, Obo.name, Obo.svg), _defineProperty(_ref, Offer.name, Offer.svg), _defineProperty(_ref, OfferInactive.name, OfferInactive.svg), _defineProperty(_ref, Open.name, Open.svg), _defineProperty(_ref, Pdf.name, Pdf.svg), _defineProperty(_ref, Phone.name, Phone.svg), _defineProperty(_ref, PhoneFilled.name, PhoneFilled.svg), _defineProperty(_ref, Placeholder.name, Placeholder.svg), _defineProperty(_ref, Plus.name, Plus.svg), _defineProperty(_ref, Popular.name, Popular.svg), _defineProperty(_ref, Question.name, Question.svg), _defineProperty(_ref, Rate.name, Rate.svg), _defineProperty(_ref, Refresh.name, Refresh.svg), _defineProperty(_ref, RefreshFilled.name, RefreshFilled.svg), _defineProperty(_ref, Reset.name, Reset.svg), _defineProperty(_ref, Search.name, Search.svg), _defineProperty(_ref, SearchFilled.name, SearchFilled.svg), _defineProperty(_ref, See.name, See.svg), _defineProperty(_ref, SeeFilled.name, SeeFilled.svg), _defineProperty(_ref, SeeHidden.name, SeeHidden.svg), _defineProperty(_ref, Share.name, Share.svg), _defineProperty(_ref, ShareFilled.name, ShareFilled.svg), _defineProperty(_ref, Shower.name, Shower.svg), _defineProperty(_ref, ShowerFilled.name, ShowerFilled.svg), _defineProperty(_ref, Sign.name, Sign.svg), _defineProperty(_ref, SignFilled.name, SignFilled.svg), _defineProperty(_ref, Sink.name, Sink.svg), _defineProperty(_ref, SinkFilled.name, SinkFilled.svg), _defineProperty(_ref, SinkVersionTwo.name, SinkVersionTwo.svg), _defineProperty(_ref, SinkVersionTwoFilled.name, SinkVersionTwoFilled.svg), _defineProperty(_ref, Sliders.name, Sliders.svg), _defineProperty(_ref, SlidersFilled.name, SlidersFilled.svg), _defineProperty(_ref, SquareFeet.name, SquareFeet.svg), _defineProperty(_ref, SquareFeetFilled.name, SquareFeetFilled.svg), _defineProperty(_ref, Star.name, Star.svg), _defineProperty(_ref, StarFilled.name, StarFilled.svg), _defineProperty(_ref, Telephone.name, Telephone.svg), _defineProperty(_ref, Trash.name, Trash.svg), _defineProperty(_ref, TrashFilled.name, TrashFilled.svg), _defineProperty(_ref, UnlockLeft.name, UnlockLeft.svg), _defineProperty(_ref, UnlockLeftFilled.name, UnlockLeftFilled.svg), _defineProperty(_ref, UnlockRight.name, UnlockRight.svg), _defineProperty(_ref, UnlockRightFilled.name, UnlockRightFilled.svg), _defineProperty(_ref, Video.name, Video.svg), _defineProperty(_ref, VideoFilled.name, VideoFilled.svg), _defineProperty(_ref, Warning.name, Warning.svg), _defineProperty(_ref, Opendoor.name, Opendoor.svg), _defineProperty(_ref, ProgressBar.name, ProgressBar.svg), _ref)); // DO NOT EXPORT: If you need all the names of the icons, use the
// SIZE_SPECIFIC__ICONS_MANIFEST

var SIZE_SPECIFIC_SPRITESHEET_ICONS = (cov_1q9eio50nx().s[1]++, (_ref2 = {}, _defineProperty(_ref2, ChevronDown12.name, ChevronDown12.svg), _defineProperty(_ref2, ChevronDown16.name, ChevronDown16.svg), _defineProperty(_ref2, ChevronLeft12.name, ChevronLeft12.svg), _defineProperty(_ref2, ChevronLeft16.name, ChevronLeft16.svg), _defineProperty(_ref2, ChevronRight12.name, ChevronRight12.svg), _defineProperty(_ref2, ChevronRight16.name, ChevronRight16.svg), _defineProperty(_ref2, ChevronUp12.name, ChevronUp12.svg), _defineProperty(_ref2, ChevronUp16.name, ChevronUp16.svg), _defineProperty(_ref2, Close16.name, Close16.svg), _ref2));
/**
 * The spritesheet component contains all of the EERO icons. It is injected once
 * per page. Individual icons are then made using the Icon component.
 * Icon takes `name` as a prop which refers to the keys in the
 * `SPRITESHEET_ICONS` object. To add an icon to the spritesheet:
 * 1. Add a new "name" to the SPRITESHEET_ICONS_MANIFEST object in ./SpritesheetManifest.tsx
 * 2. Add a new file to './SpritesheetIcons/YourNewIcon.tsx' and export
 *    the `name` and `svg` object.
 * 3. Add to the SPRITESHEET_ICONS object, by importing and adding
 *    import YourNewIcon from './SpritesheetIcons/YourNewIcon'
 *    ...
 *    [YourNewIcon.name]: YourNewIcon.svg
 * a key and the raw SVG code as value to the `SPRITESHEET_ICONS` object.
 *
 * When adding an icon to the spritesheet for which the color is meant to be
 * dynamic set each fill and stroke that is meant to be a dynamic color to
 * `currentColor`. For icons with static colors leave the strokes and fills as
 * is.
 *
 * [One-pager](https://docs.google.com/document/d/16wEXOzW3fPz3WafU6wJ8gtYAJl70_CE8TJUP8_-rgYs/edit?usp=sharing)
 */

export default function Spritesheet() {
  cov_1q9eio50nx().f[0]++;
  cov_1q9eio50nx().s[2]++;
  return /*#__PURE__*/React.createElement(bricks.svg, {
    opacity: 0,
    width: 0,
    height: 0,
    display: "block",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, Object.keys(SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[1]++;
    cov_1q9eio50nx().s[3]++;
    return /*#__PURE__*/React.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SPRITESHEET_ICONS[id]
      }
    });
  }), Object.keys(SIZE_SPECIFIC_SPRITESHEET_ICONS).map(function (id) {
    cov_1q9eio50nx().f[2]++;
    cov_1q9eio50nx().s[4]++;
    return /*#__PURE__*/React.createElement("g", {
      key: id,
      id: id,
      dangerouslySetInnerHTML: {
        __html: SIZE_SPECIFIC_SPRITESHEET_ICONS[id]
      }
    });
  })));
}